/**
 * S3 URL builder utility functions
 *
 * 公開バケット: 直接S3 URLを構築（lecture.json, notice.json）
 */

function getPublicBaseUrl(): string {
  return import.meta.env.VITE_S3_PUBLIC_BASE_URL ?? 'http://localhost:9000/ws-l-minio';
}

/**
 * Build S3 URL for lecture.json (public bucket)
 * Path: {base_url}/{tenant_url_slug}/upload/json/lecture/{internal_id}/lecture.json
 * Preview: {base_url}/{tenant_url_slug}/preview/upload/json/lecture/{internal_id}/lecture.json
 */
export function buildLectureUrl(
  tenantSlug: string,
  internalId: string,
  isPreview: boolean = false
): string {
  const baseUrl = getPublicBaseUrl();
  const previewPath = isPreview ? '/preview' : '';
  return `${baseUrl}/${tenantSlug}${previewPath}/upload/json/lecture/${internalId}/lecture.json`;
}

/**
 * Build S3 URL for notice.json (public bucket)
 * Path: {base_url}/{tenant_url_slug}/upload/json/lecture/notice.json
 * Preview: {base_url}/{tenant_url_slug}/preview/upload/json/lecture/notice.json
 */
export function buildNoticeUrl(
  tenantSlug: string,
  isPreview: boolean = false
): string {
  const baseUrl = getPublicBaseUrl();
  const previewPath = isPreview ? '/preview' : '';
  return `${baseUrl}/${tenantSlug}${previewPath}/upload/json/lecture/notice.json`;
}
